import { SettingsColumn } from "./SettingsColumn";
import { ColumnBase } from "./ColumnBase";
import { Columns } from "./Columns";
import { TableColumnTypes } from "./TableColumnTypes";
import { app } from "../../Frame/App";
import { BooleanLinkTypes } from "../../Pages/Measure/Dependencies/ContentBooleanLink";

export class Settings {
    public columns: { [id: string]: SettingsColumn } = {};
    public sortField: string;
    public sortAsc: boolean;
    //public sortSecondField: string = "";
    //public sortSecondAsc: boolean = false;

    public static read(settingsName: string, columns: Columns): Settings {
        let result: Settings = null;
        if (settingsName && settingsName.length > 0) {
            const json = localStorage.getItem(settingsName);
            if (json && json.length > 0) {
                let item = JSON.parse(json);
                result = new Settings();
                Object.assign(result, item);
            
                // set column width
                for (let col of columns.items) {
                    if (result.columns[col.field]) {
                        col.width = result.columns[col.field].width;
                    }
                }

                if (!result.sortField) {
                    for (let col of columns.items) {
                        if (col.isSortable) {
                            result.sortField = col.field;
                            result.sortAsc = col.sortAsc;
                            break;
                        }
                    }
                }
            }
        }

        if (!result) {
            // create default settings
            result = new Settings();

            // set default sort
            if (columns && columns.items && columns.items.length > 0) {
                if (columns.items[0].type == TableColumnTypes.Expand) {
                    this.setDefaultCol(result, columns, columns.items[1].field);
                    result.sortAsc = true;
                }
                else 
                    this.setDefaultCol(result, columns, columns.items[0].field);
            }
        }

        return result;
    }

    private static setDefaultCol(result: Settings, columns: Columns, field:string) {
        if (window.location.pathname.toLowerCase() == app.resolveUrl("~/measures")) {

            if (columns.items.find(f => f.field == "Ampel")) 
                result.sortField = columns.items.find(f => f.field == "Ampel").field;
            else
                result.sortField = field;
            result.sortAsc = false;
        } else {
            result.sortField = field;
            result.sortAsc = true;
        }
    }


    public setWidth(field: string, width: number) {
        if (!this.columns[field]) {
            this.columns[field] = new SettingsColumn();
            this.columns[field].field = field;
        }
        this.columns[field].width = width;
    }

    public write(settingsName: string) {
        if (settingsName && settingsName.length > 0) {
            localStorage.setItem(settingsName, JSON.stringify(this));
        }
    }

    public delete(field: string, settingsName: string) {
        if (settingsName && settingsName.length > 0) {
            if (field == this.sortField) {
                //remove first sort
                this.sortField = "";
                this.sortAsc = false;
            }

            // remove settings
            if (this.sortField == "")
                localStorage.removeItem(settingsName);
        }
    }
}
